{
  "groups": {
    "referenceNumber": "หมายเลขอ้างอิง",
    "appointmentStartTimes": "เวลาเริ่มการนัดหมาย",
    "appointmentNotifications": "การแจ้งเตือนการนัดหมาย",
    "appointmentStatuses": "สถานะการนัดหมาย",
    "customAppointmentsGrid": "ตารางการนัดหมายแบบกำหนดเอง",
    "limiter": "ตัวจำกัด",
    "schedulingPortal": "พอร์ทัลการนัดหมาย",
    "dockSelection": "การเลือกท่าเทียบรถ",
    "timeDisplay": "การแสดงเวลา",
    "gateManagement": "การจัดการประตูทางเข้า",
    "smartGate": "SmartGate",
    "idValidation": "การยืนยันตัวตน",
    "appointmentValidation": "การตรวจสอบการนัดหมาย",
    "other": "อื่น ๆ",
    "handlingUnits": "หน่วยขนถ่ายสินค้า"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "หมายเลขอ้างอิงคือข้อมูลอ้างอิงที่คุณสามารถขอจากผู้ขนส่งเมื่อทำการนัดหมาย",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "กำหนดช่วงเวลาที่อนุญาตให้เริ่มการนัดหมาย",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "จัดการการแจ้งเตือนการนัดหมายทุกประเภทสำหรับ{entity}นี้",
    "manageTheSchedulingPortalSettingsForThisEntity": "จัดการการตั้งค่าพอร์ทัลการนัดหมายสำหรับ{entity}นี้",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "หน่วยขนถ่ายสินค้าเป็นช่องตัวเลขสำหรับขอจำนวนหน่วย (เช่น พาเลท) ระหว่างการนัดหมาย เพิ่มช่องนี้ลงในแบบฟอร์มของคุณเพื่อเปิดใช้งานฟีเจอร์ตัวจำกัดด้วย",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "ตัวจำกัดช่วยให้คุณกำหนดจำนวนการนัดหมายหรือหน่วยขนถ่ายสินค้า (เช่น พาเลท) สูงสุดที่สามารถนัดหมายได้ต่อวัน"
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "จำนวนหมายเลขอ้างอิงขั้นต่ำ",
    "maximumAmountOfReferenceNumbers": "จำนวนหมายเลขอ้างอิงสูงสุด",
    "includeReferenceNumberFieldOnAllAppointmentForms": "รวมช่องหมายเลขอ้างอิงในแบบฟอร์มการนัดหมายทั้งหมดหรือไม่",
    "referenceNumberFieldName": "ชื่อช่องหมายเลขอ้างอิง",
    "referenceNumberHelperText": "ข้อความช่วยเหลือของหมายเลขอ้างอิง",
    "makeReferenceNumberARequiredField": "กำหนดให้หมายเลขอ้างอิงเป็นช่องที่จำเป็นหรือไม่",
    "allowAppointmentsForThisEntityToStartAt": "อนุญาตให้การนัดหมายสำหรับ{entity}นี้เริ่มที่:",
    "enableAppointmentNotificationsForThisEntity": "เปิดใช้งานการแจ้งเตือนการนัดหมายสำหรับ{entity}นี้หรือไม่",
    "selectEachDesiredStartTimeIndividually": "เลือกเวลาเริ่มต้นที่ต้องการทีละรายการ",
    "hideTheLoadTypeDuration": "ซ่อนระยะเวลาของประเภทสินค้าหรือไม่",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "อัปโหลดโลโก้{entity}ของคุณเพื่อแสดงในพอร์ทัลการนัดหมายและในการแจ้งเตือนทางอีเมลทั้งหมด",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "อัปโหลดแผนที่ลานจอดของคลังสินค้าเพื่อแสดงในพอร์ทัลการนัดหมาย",
    "statusForNewlyCreatedAppointments": "สถานะสำหรับการนัดหมายที่สร้างใหม่",
    "muteAppointmentNotifications": "ปิดเสียงการแจ้งเตือนการนัดหมาย",
    "allowDockSelectionInSchedulingPortal": "อนุญาตให้เลือกท่าเทียบรถในพอร์ทัลการนัดหมายหรือไม่",
    "theStatusThatFollowsArrivedIs": "สถานะที่ตามหลัง 'มาถึงแล้ว' คือ",
    "displayTimeIn": "แสดงเวลาเป็น:",
    "customizeAppointmentDetails": "ปรับแต่งรายละเอียดการนัดหมาย",
    "gridTileConfig": "การกำหนดค่าไทล์ตาราง",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "บังคับใช้การกำหนดขอบเขตพื้นที่ (Geofencing) เพื่อให้คนขับต้องระบุตำแหน่งแบบเรียลไทม์",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "คุณต้องการแสดงข้อมูลเพิ่มเติมแก่คนขับหลังจากเช็กอินหรือไม่ (ไม่บังคับ)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "ป้องกันการเลื่อนนัดในพอร์ทัลการนัดหมายหรือไม่",
    "revertToRequestedOnCarrierReschedule": "เปลี่ยนกลับเป็น 'ส่งคำขอแล้ว' เมื่อผู้ขนส่งเลื่อนนัด",
    "observationMatchAttribute": "แอตทริบิวต์สำหรับจับคู่การตรวจพบ",
    "observationMatchTimeWindow": "ช่วงเวลาสำหรับจับคู่การตรวจพบ",
    "autoDepartAssets": "ออกจากพื้นที่อัตโนมัติสำหรับอุปกรณ์",
    "autoCreateAssets": "สร้างอุปกรณ์อัตโนมัติ",
    "gateFeedColumns": "คอลัมน์ Gate Feed",
    "checkInEarlyThreshold": "เกณฑ์การเช็กอินก่อนเวลา",
    "checkInLateThreshold": "เกณฑ์การเช็กอินล่าช้า",
    "technicalContactEmailAddress": "ที่อยู่อีเมลผู้ติดต่อด้านเทคนิค",
    "technicalContactEmailThrottleMinutes": "ระยะห่างการส่งอีเมลถึงผู้ติดต่อด้านเทคนิค (นาที)",
    "requireUniqueReferenceNumbers": "กำหนดให้หมายเลขอ้างอิงต้องไม่ซ้ำกัน",
    "appointmentStartTimeInterval": "ช่วงห่างของเวลาเริ่มการนัดหมาย",
    "referenceNumberInputMode": "โหมดการกรอกหมายเลขอ้างอิง",
    "uploadWarehouseYardMap": "อัปโหลดแผนที่ลานจอดของคลังสินค้าเพื่อแสดงในพอร์ทัลการนัดหมาย",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "รวมช่องหน่วยขนถ่ายสินค้าในแบบฟอร์มการนัดหมายทั้งหมดหรือไม่",
    "handlingUnitsLabel": "ป้ายกำกับหน่วยขนถ่ายสินค้า",
    "handlingUnitsHelperText": "ข้อความช่วยเหลือของหน่วยขนถ่ายสินค้า",
    "makeHandlingUnitsARequiredField": "กำหนดให้หน่วยขนถ่ายสินค้าเป็นช่องที่จำเป็นหรือไม่",
    "maximumHandlingUnitsValueForAnAppointment": "ค่าหน่วยขนถ่ายสินค้าสูงสุดสำหรับการนัดหมาย",
    "minimumHandlingUnitsValueForAnAppointment": "ค่าหน่วยขนถ่ายสินค้าขั้นต่ำสำหรับการนัดหมาย",
    "checkOutBolSignedRequired": "ต้องลงนาม BOL เมื่อเช็กเอาต์",
    "checkOutBolNotLoadingErrorMessage": "ข้อความแสดงข้อผิดพลาดเมื่อโหลด BOL ไม่ได้ขณะเช็กเอาต์",
    "checkOutIdentifier": "ข้อมูลระบุตัวตนสำหรับเช็กเอาต์",
    "enableCheckInIdValidationPersona": "เปิดใช้งานการยืนยันตัวตนเมื่อเช็กอิน (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "กำหนดให้ต้องยืนยันตัวตนเพื่อเช็กอินให้เสร็จสมบูรณ์",
    "checkInIdValidationTemplate": "เทมเพลตการยืนยันตัวตนเมื่อเช็กอิน",
    "geofenceRadius": "รัศมีขอบเขตพื้นที่",
    "createAppointmentOnExternalValidationFailure": "สร้างการนัดหมายเมื่อการตรวจสอบภายนอกล้มเหลว",
    "enableOverrideLimiterFunction": "เปิดใช้งานฟังก์ชันข้ามตัวจำกัด",
    "receiveUnplannedCheckInEmailNotifications": "รับการแจ้งเตือนทางอีเมลสำหรับการเช็กอินที่ไม่ได้วางแผน",
    "driversMustEnterAReferenceNumberToCheckIn": "คนขับต้องกรอกหมายเลขอ้างอิงเพื่อเช็กอิน",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "คนขับจะเช็กอินได้เฉพาะเมื่อหมายเลขอ้างอิงตรงกับการนัดหมายที่กำหนดไว้",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "คนขับข้ามขั้นตอนหมายเลขอ้างอิงระหว่างการเช็กอิน",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "ปรับแต่งข้อความ SMS แรกที่คนขับได้รับหลังเช็กอิน (ไม่บังคับ)",
    "includeYardMapImageInTheFirstCheckInSms": "รวมรูปภาพแผนที่ลานจอดใน SMS เช็กอินข้อความแรกหรือไม่",
    "automaticallyDeleteStoredIdValidations": "ลบข้อมูลการยืนยันตัวตนที่จัดเก็บไว้โดยอัตโนมัติ",
    "deleteStoredIdValidationsAfter": "ลบข้อมูลการยืนยันตัวตนที่จัดเก็บไว้หลังจาก",
    "displayDatesAs": "แสดงวันที่เป็น:",
    "displayTimeAs": "แสดงเวลาเป็น:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "กำหนดให้การนัดหมายต้องมีหมายเลขอ้างอิงอย่างน้อยตามจำนวนนี้",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "กำหนดให้การนัดหมายมีหมายเลขอ้างอิงได้ไม่เกินจำนวนนี้",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "ชื่อที่แสดงสำหรับช่องหมายเลขอ้างอิง เช่น \"หมายเลข PO\", \"ID การจัดส่ง\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "ข้อมูลเพิ่มเติมเพื่อช่วยในการกรอกช่องหมายเลขอ้างอิง เช่น \"หมายเลขอ้างอิงควรขึ้นต้นด้วย OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "กำหนดให้ต้องระบุหมายเลขอ้างอิงสำหรับการนัดหมายทั้งหมด",
    "thisOnlyAffectsNewlyCreatedAppointments": "การตั้งค่านี้มีผลเฉพาะกับการนัดหมายที่สร้างใหม่เท่านั้น",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "ระยะเวลาจะแสดงในรายการเลือกประเภทสินค้าเมื่อจองการนัดหมายในพอร์ทัลการนัดหมาย",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "อนุญาตให้เลือกท่าเทียบรถเมื่อจองการนัดหมายในพอร์ทัลการนัดหมาย",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "การตั้งค่านี้จะอนุญาตให้เลือกสถานะ 'กำลังดำเนินการ' ระหว่าง 'มาถึงแล้ว' และ 'เสร็จสิ้น'",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "กำหนดรูปแบบการแสดงเวลาทั่วทั้งแพลตฟอร์มสำหรับผู้ใช้ทั้งหมดขององค์กรนี้ รวมถึงตารางการนัดหมายและรายงาน",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "เปิดใช้งานเพื่อเปลี่ยนไปใช้ระบบรายละเอียดการนัดหมายแบบใหม่ที่ปรับแต่งได้",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "การกำหนดค่าของผู้ใช้สำหรับรูปแบบการแสดงไทล์ตาราง",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "การตั้งค่านี้จะขอตำแหน่งของคนขับ และจำกัดไม่ให้เช็กอินเมื่ออยู่ห่างจากคลังสินค้าของคุณมากกว่าหนึ่งไมล์",
    "preventCarriersFromReschedulingAppointmentsOptional": "ป้องกันไม่ให้ผู้ขนส่งเลื่อนนัด (ไม่บังคับ)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "เมื่อผู้ขนส่งเลื่อนการนัดหมายที่มีสถานะ 'นัดหมายแล้ว' ให้เปลี่ยนกลับเป็น 'ส่งคำขอแล้ว' เพื่ออนุมัติใหม่",
    "attributeToBeUsedForMatchingObservations": "แอตทริบิวต์ที่ใช้สำหรับจับคู่การตรวจพบ",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "จำนวนนาทีที่นับรวมการตรวจพบก่อนและหลังเวลาเช็กอิน",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "จำนวนนาทีก่อนเวลาเริ่มนัดหมายที่ผู้ขนส่งสามารถเช็กอินได้",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "จำนวนนาทีหลังเวลาเริ่มนัดหมายที่ผู้ขนส่งสามารถเช็กอินได้",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "ที่อยู่อีเมลที่จะใช้ส่งปัญหาและข้อมูลด้านเทคนิค",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "ระยะเวลาระหว่างการแจ้งเตือนที่ส่งถึงผู้ติดต่อด้านเทคนิคเมื่อเซิร์ฟเวอร์ตรวจสอบเกิดข้อผิดพลาด",
    "aListOfMutedAppointmentNotifications": "รายการการแจ้งเตือนการนัดหมายที่ปิดเสียงไว้",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "กำหนดให้หมายเลขอ้างอิงต้องไม่ซ้ำกันสำหรับการนัดหมายทั้งหมด",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "นี่คือช่วงห่างเป็นนาทีระหว่างเวลาที่การนัดหมายสามารถเริ่มได้",
    "enableTheCustomAppointmentStartTimesSetting": "เปิดใช้งานการตั้งค่าเวลาเริ่มการนัดหมายแบบกำหนดเอง",
    "theInputModeForTheReferenceNumberField": "โหมดการกรอกสำหรับช่องหมายเลขอ้างอิง",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "ชื่อที่แสดงสำหรับช่องประเภทหน่วย เช่น จำนวนพาเลท จำนวนสกิด",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "กำหนดให้ต้องระบุช่องประเภทหน่วยสำหรับการนัดหมายทั้งหมด",
    "autoDepartAssetsOnReceivingOutgateEvent": "ให้อุปกรณ์ออกจากพื้นที่อัตโนมัติเมื่อได้รับเหตุการณ์ออกจากประตู",
    "autoCreateAssetsOnReceivingIngateEvent": "สร้างอุปกรณ์อัตโนมัติเมื่อได้รับเหตุการณ์เข้าประตู",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "คอลัมน์ที่ใช้ได้ในหน้า AI Gate Feed คอลัมน์ที่จำเป็นจะแสดงเสมอ",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "สร้างการนัดหมายแม้ว่าการตรวจสอบการนัดหมายจะไม่ผ่าน",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "รัศมีเป็นไมล์ที่คนขับต้องอยู่ภายในเพื่อเช็กอิน ใช้ได้เฉพาะเมื่อเปิดใช้งานการกำหนดขอบเขตพื้นที่ (Geofencing)",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "ข้อมูลเพิ่มเติมเพื่อช่วยในการกรอกช่องประเภทหน่วย เช่น ประเภทหน่วยควรเป็นตัวเลขเท่านั้น",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "กำหนดค่าตัวเลขสูงสุดที่สามารถกรอกในช่องหน่วยขนถ่ายสินค้าของการนัดหมาย",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "กำหนดค่าตัวเลขขั้นต่ำที่สามารถกรอกในช่องหน่วยขนถ่ายสินค้าของการนัดหมาย",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "เมื่อตัวจำกัดถึง 100% ฟีเจอร์นี้จะอนุญาตให้เฉพาะผู้ใช้คลังสินค้าข้ามขีดจำกัดเพื่อสร้างหรืออนุมัติการนัดหมายและหน่วยได้",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "แอตทริบิวต์ของอุปกรณ์ที่ระบบจะใช้ตรวจสอบแบบฟอร์มเช็กเอาต์",
    "enforceBolSigningOnCheckOutForm": "บังคับให้ลงนาม BOL ในแบบฟอร์มเช็กเอาต์",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "หาก BOL ไม่พร้อมใช้งาน ผู้ขนส่งจะไม่สามารถลงนามได้ และการเช็กเอาต์จะถูกบล็อก คุณสามารถกำหนดคำแนะนำที่คนขับจะเห็นในกรณีนี้ได้ที่นี่",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "แสดงคอมโพเนนต์ Persona ในขั้นตอนการเช็กอินเพื่อยืนยันตัวตน",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "กำหนดให้ต้องยืนยันตัวตนผ่าน Persona สำเร็จก่อนที่คนขับจะเช็กอินให้เสร็จสมบูรณ์ได้",
    "personaTemplateUsedForCheckInIdentityVerification": "เทมเพลต Persona ที่ใช้สำหรับการยืนยันตัวตนเมื่อเช็กอิน",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "ผู้รับการแจ้งเตือนของคลังสินค้าจะได้รับการแจ้งเตือนทางอีเมลเมื่อมีการเช็กอินที่ไม่ได้วางแผน",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "ข้อความนี้จะแทนที่ข้อความยืนยันการเช็กอินเริ่มต้นที่ส่งถึงคนขับทาง SMS เว้นว่างไว้เพื่อใช้ข้อความเริ่มต้น",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "ส่งแผนที่ลานจอดของคุณเป็นข้อความรูปภาพแยกต่างหากทันทีหลัง SMS เช็กอิน ต้องอัปโหลดแผนที่ลานจอดสำหรับคลังสินค้านี้ก่อน",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "ระเบียนการยืนยันตัวตนที่จัดเก็บไว้จะถูกลบอย่างถาวรเมื่อพ้นระยะเวลาการเก็บรักษา",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "จำนวนวันที่จัดเก็บข้อมูลการยืนยันตัวตนไว้ก่อนที่จะถูกลบ",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "กำหนดรูปแบบการแสดงวันที่สำหรับผู้ใช้ของบริษัทนี้ในทุกหน้าที่บริษัทใช้งาน",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "กำหนดรูปแบบการแสดงเวลาสำหรับผู้ใช้ของบริษัทนี้ในทุกหน้าที่บริษัทใช้งาน"
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "หมายเลขอ้างอิงที่เชื่อมโยงกับการนัดหมาย",
    "insertMessageHere": "ใส่ข้อความที่นี่"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "ต้นชั่วโมง (:00)",
      "topAndBottomOfTheHour00And30": "ต้นชั่วโมงและครึ่งชั่วโมง (:00 และ :30)",
      "everyTwentyMinutes0020And40": "ทุก 20 นาที (:00, :20 และ :40)",
      "everyQuarterOfTheHour001530And45": "ทุก 15 นาที (:00, :15, :30 และ :45)",
      "customStartTimes": "เวลาเริ่มต้นแบบกำหนดเอง"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 นาที",
      "30Minutes": "30 นาที",
      "60Minutes": "60 นาที",
      "90Minutes": "90 นาที"
    },
    "observationMatchAttribute": {
      "licensePlate": "ป้ายทะเบียน",
      "dotNumber": "หมายเลข DOT",
      "any": "ใดก็ได้",
      "cascade": "ตามลำดับ (Cascade)"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "ตัวอักษรและตัวเลข",
      "numeric": "ตัวเลข"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "นัดหมายแล้ว",
      "requested": "ส่งคำขอแล้ว"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "กำลังดำเนินการ",
      "completed": "เสร็จสิ้น"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "ไม่ ไม่ต้องรวมช่องหมายเลขอ้างอิง",
      "yesIncludeTheReferenceNumberField": "ใช่ รวมช่องหมายเลขอ้างอิง"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "ไม่ ไม่ต้องซ่อนระยะเวลาของประเภทสินค้า",
      "yesHideTheLoadTypeDuration": "ใช่ ซ่อนระยะเวลาของประเภทสินค้า"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "ไม่ ปิดใช้งานการแจ้งเตือนการนัดหมาย",
      "yesEnableAppointmentNotifications": "ใช่ เปิดใช้งานการแจ้งเตือนการนัดหมาย"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "ไม่ ไม่อนุญาตให้เลือกท่าเทียบรถ",
      "yesAllowTheDockSelection": "ใช่ อนุญาตให้เลือกท่าเทียบรถ"
    },
    "displayTimeIn": {
      "regularTime12Hour": "เวลาปกติ (12 ชั่วโมง)",
      "militaryTime24Hour": "เวลาแบบ 24 ชั่วโมง"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "อนุญาตให้เลื่อนนัดในพอร์ทัลการนัดหมาย",
      "preventReschedulingInTheSchedulingPortal": "ป้องกันการเลื่อนนัดในพอร์ทัลการนัดหมาย"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "เปลี่ยนกลับเป็น 'ส่งคำขอแล้ว' เมื่อผู้ขนส่งเลื่อนนัด",
      "keepStatusUnchangedOnCarrierReschedule": "คงสถานะเดิมไว้เมื่อผู้ขนส่งเลื่อนนัด"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "ไม่ ไม่ต้องกำหนดให้หมายเลขอ้างอิงเป็นช่องที่จำเป็น",
      "yesMakeReferenceNumberARequiredField": "ใช่ กำหนดให้หมายเลขอ้างอิงเป็นช่องที่จำเป็น"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "ไม่ ไม่ต้องกำหนดให้หมายเลขอ้างอิงไม่ซ้ำกัน",
      "yesRequireUniqueReferenceNumbers": "ใช่ กำหนดให้หมายเลขอ้างอิงต้องไม่ซ้ำกัน"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "ไม่ ไม่ต้องกำหนดให้หน่วยขนถ่ายสินค้าเป็นช่องที่จำเป็น",
      "yesMakeHandlingUnitsARequiredField": "ใช่ กำหนดให้หน่วยขนถ่ายสินค้าเป็นช่องที่จำเป็น"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "ไม่ ไม่ต้องรวมช่องหน่วยขนถ่ายสินค้า",
      "yesIncludeTheHandlingUnitsField": "ใช่ รวมช่องหน่วยขนถ่ายสินค้า"
    },
    "checkOutIdentifier": {
      "licensePlate": "ป้ายทะเบียน",
      "phoneNumber": "หมายเลขโทรศัพท์",
      "any": "ใดก็ได้"
    },
    "enableCheckInIdValidationPersona": {
      "no": "ไม่",
      "yes": "ใช่"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "ไม่",
      "yes": "ใช่"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "ใบขับขี่ - ด้านหน้า - ลองใหม่ได้ 1 ครั้ง",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "ใบขับขี่ - ด้านหน้า บาร์โค้ด ใบหน้า เฉพาะสหรัฐอเมริกา ลองใหม่ได้ 1 ครั้ง"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "ไม่",
      "yes": "ใช่"
    },
    "displayDatesAs": {
      "mmDdYyyy": "ดด/วว/ปปปป",
      "ddMmYyyy": "วว/ดด/ปปปป",
      "yyyyMmDd": "ปปปป-ดด-วว",
      "tueMmDdYyyy": "อ., ดด/วว/ปปปป",
      "tueDdMmYyyy": "อ., วว/ดด/ปปปป",
      "tueYyyyMmDd": "อ., ปปปป-ดด-วว"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 ชั่วโมง (เช่น 7:00 AM)",
      "24HourEG0700": "24 ชั่วโมง (เช่น 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "เช่น 7:00 AM / 7:00 PM",
      "eG07001900": "เช่น 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "หมายเหตุ:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "หากเว้นว่างไว้ ระบบจะใช้ชื่อเริ่มต้น",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "หากเว้นว่างไว้ ระบบจะใช้ข้อความช่วยเหลือเริ่มต้น",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "การเปิดใช้งานตัวเลือกนี้จะไม่ส่งผลต่อการแจ้งเตือนที่ปิดใช้งานไว้แล้วในระดับการนัดหมายแต่ละรายการ",
    "ifLeftEmptyNoNotificationsWillBeSent": "หากเว้นว่างไว้ จะไม่มีการส่งการแจ้งเตือน",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "หมายเลขอ้างอิงที่กำหนดให้กับการนัดหมายที่ยกเลิกหรือไม่มาตามนัด อาจนำมาใช้ซ้ำกับการนัดหมายใหม่ได้",
    "ifEmptyTheDefaultNameWillBeApplied": "หากว่างไว้ ระบบจะใช้ชื่อเริ่มต้น"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "คนขับ",
    "checkInSms": "SMS เช็กอิน",
    "dataRetention": "การเก็บรักษาข้อมูล"
  }
}
